import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { SectorBuilder } from '../../models/builder/sector.builder';

@Injectable()
export class SectorApiService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient
  ) {
    this.apiUrl = `${ environment.companyAdmin.apiUrl }sectors`;
  }

  getSectors() {
    return this.httpClient.get(`${ this.apiUrl }`)
      .pipe(map(SectorBuilder.fromList));
  }
}
